import {atom, useAtomValue} from 'jotai'

const onlineAtom = atom(navigator.onLine)

onlineAtom.onMount = (set) => {
  const handleOnline = () => set(true)
  const handleOffline = () => set(false)

  window.addEventListener('online', handleOnline)
  window.addEventListener('offline', handleOffline)

  return () => {
    window.removeEventListener('online', handleOnline)
    window.removeEventListener('offline', handleOffline)
  }
}

export function useOnlineStatus(): boolean {
  return useAtomValue(onlineAtom)
}
